import { render, staticRenderFns } from "./ArticleAuthor.vue?vue&type=template&id=6644ec1e&scoped=true"
import script from "./ArticleAuthor.vue?vue&type=script&lang=ts"
export * from "./ArticleAuthor.vue?vue&type=script&lang=ts"
import style0 from "./ArticleAuthor.vue?vue&type=style&index=0&id=6644ec1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6644ec1e",
  null
  
)

export default component.exports